import CloseOutlined from "@mui/icons-material/CloseOutlined";
import {
	MODAL_CLOSE_BUTTON_CLASS,
	MODAL_CLOSE_BUTTON_OVERLAY_CLASS,
	MODAL_CLOSE_ICON_SIZE,
} from "@config/theme/modal";

interface ModalCloseButtonProps {
	onClose: () => void;
	variant?: "default" | "overlay";
	className?: string;
}

const ModalCloseButton: React.FC<ModalCloseButtonProps> = ({
	onClose,
	variant = "default",
	className = "",
}) => {
	const isOverlay = variant === "overlay";

	return (
		<button
			type="button"
			onClick={onClose}
			aria-label="Close"
			data-testid="modal-close-button"
			className={`${isOverlay ? MODAL_CLOSE_BUTTON_OVERLAY_CLASS : MODAL_CLOSE_BUTTON_CLASS} ${className}`.trim()}>
			<CloseOutlined sx={{ fontSize: MODAL_CLOSE_ICON_SIZE, fontWeight: 600 }} />
		</button>
	);
};

export default ModalCloseButton;
